if (!customElements.get('top-banner-slider-controller')) {
  class TopBannerSlider extends HTMLElement {
    constructor() {
      super();

      this.swiperInstance = null;
      this.desktopQuery = window.matchMedia('(min-width: 1024px)');
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.update = this.update.bind(this);
      this.handleFocusIn = this.handleFocusIn.bind(this);
      this.handleFocusOut = this.handleFocusOut.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
    }

    connectedCallback() {
      if (Number(this.dataset.slideCount) < 2) return;

      this.desktopQuery.addEventListener('change', this.update);
      this.reducedMotionQuery.addEventListener('change', this.update);
      this.addEventListener('focusin', this.handleFocusIn);
      this.addEventListener('focusout', this.handleFocusOut);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

      this.update();
    }

    disconnectedCallback() {
      this.desktopQuery.removeEventListener('change', this.update);
      this.reducedMotionQuery.removeEventListener('change', this.update);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.removeEventListener('focusout', this.handleFocusOut);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);

      this.destroySwiper();
    }

    update() {
      this.destroySwiper();

      if (!this.desktopQuery.matches) this.initSwiper();
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') return;

      const autoplay = this.reducedMotionQuery.matches
        ? false
        : {
            delay: Number(this.dataset.delay),
            reverseDirection: this.dataset.direction !== 'bottom_to_top',
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          };

      this.swiperInstance = new Swiper(this, {
        direction: 'vertical',
        loop: true,
        slidesPerView: 1,
        speed: Number(this.dataset.speed),
        autoplay,
      });

      if (this.contains(document.activeElement)) this.stopAutoplay();

      this.setAttribute('aria-roledescription', this.dataset.carouselLabel);
    }

    destroySwiper() {
      if (!this.swiperInstance) return;

      if (!this.swiperInstance.destroyed) this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
      this.removeAttribute('aria-roledescription');
    }

    stopAutoplay() {
      if (this.swiperInstance?.autoplay?.running) this.swiperInstance.autoplay.stop();
    }

    startAutoplay() {
      if (this.swiperInstance?.params.autoplay.enabled) this.swiperInstance.autoplay.start();
    }

    handleFocusIn() {
      this.stopAutoplay();
    }

    handleFocusOut(event) {
      if (!this.contains(event.relatedTarget)) this.startAutoplay();
    }

    handleBlockSelect(event) {
      const slide = event.target.closest('.swiper-slide');
      if (!this.swiperInstance || !slide) return;

      this.stopAutoplay();
      this.swiperInstance.slideToLoop(Number(slide.dataset.swiperSlideIndex), 0);
    }

    handleBlockDeselect() {
      this.startAutoplay();
    }
  }

  customElements.define('top-banner-slider-controller', TopBannerSlider);
}
